$(function () {
  $('#drawingModal').on('show.bs.modal', function (event) {
    var $button = $(event.relatedTarget); // Button that triggered the modal
    var $drawingModalImage = $button.find('.drawingModalImg').clone(false, false); // clone element to avoid origin element to be moved to modal (and later removed)
    var myModalLabel = $button.data('title');
    // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
    // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
    var $modal = $(this);
    var $modalBody = $modal.find('.modal-body');
    $modal.find('.modal-header #myModalLabel').text(myModalLabel);
    $modalBody.empty();
    $modalBody.append($drawingModalImage);
    $modalBody.find('.drawingModalImg').show();
  });

  //Show more or less
  var mediaItemsList = document.getElementsByClassName('fileListing-fileList');
  if (typeof mediaItemsList[0] != 'undefined') {
    var caret = '<svg viewBox="0 0 9.4 13.7" class="fileListing-showMoreCaret" xmlns="http://www.w3.org/2000/svg"><path d= "M1.5 13.5L.2 12l6-5.1-6-5.2L1.5.2l7.7 6.7z" fill="currentColor"></path></svg>';
    var showMore = '<button class="fileListing-btn">Show more ' + caret + '</button>';
    var showLess = '<button class="fileListing-btn">Show less ' + caret + '</button>';
    var mediaItemsListItems = mediaItemsList[0].children;
    if (mediaItemsListItems.length > 3) {
      var node = document.createElement('div');
      node.classList.add('fileListing-showMoreButton');
      node.innerHTML = showMore;
      mediaItemsList[0].parentNode.appendChild(node);
    }
    $('.fileListing-showMoreButton').on('click', function (e) {
      var documentsList = $('.fileListing-fileList');
      if (documentsList.hasClass('fileListing-collapsed')) {
        $(documentsList[0]).animate({
          "height": mediaItemsListItems.length * 70 + "px"
        }, 600);
        documentsList[0].classList.remove('fileListing-collapsed');
        node.innerHTML = showLess;
      } else {
        $(documentsList[0]).animate({
          "height": "210px"
        }, 600);
        documentsList[0].classList.add('fileListing-collapsed');
        node.innerHTML = showMore;
      }
    });
  }
  //Show more or less end
});